<template>
  <div class="ordertype-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('ordertype_edit')"/>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-basket</v-icon>{{$t('order.types')}}</h1> <!-- TODO change icon -->
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <OrderTypesFilterForm
                ref="filterForm"
                :values="filters"
                slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :items-per-page.sync="options.itemsPerPage"
              :footer-props="footer"
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              :server-items-length="totalItems"
              class="elevation-1"
              item-key="@id"
              @update:options="onUpdateOptions"
              @click:row="showHandler"
              @contextmenu:row="showHandlerExt"
          >

          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import OrderTypesFilterForm from '../../components/ordertype/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'OrderTypeList',
  servicePrefix: 'OrderType',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    OrderTypesFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
      ],
      selected: [],
      footer: {
        'itemsPerPageText': "",
      },
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('ordertype', {
      items: 'list'
    }),
    ...mapFields('ordertype', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('ordertype', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
